// extracted by mini-css-extract-plugin
export default {"app":"App_app__GuJBs","canvas":"App_canvas__FZgRx","header-title":"App_header-title__P7M6-"};